import { Host, h } from "@stencil/core";
import { getFormConstraints } from "../../utils/FormDefinition";
export class ApieFormFieldDefinition {
    constructor() {
        this.name = undefined;
        this.label = undefined;
        this.types = 'text';
        this.additionalSettings = {};
        this.status = 'idle';
        this.prototyped = false;
        this.valueWhenMissing = null;
        this.allowsNull = false;
        this.emptyStringAllowed = false;
        this.required = false;
    }
    async getDefinition() {
        this.status = 'building';
        const constraints = await getFormConstraints(this.el);
        this.status = 'built';
        return Promise.resolve({
            fieldType: 'single',
            name: this.name,
            label: this.label,
            types: this.types.split(','),
            valueWhenMissing: this.valueWhenMissing,
            additionalSettings: this.additionalSettings,
            allowsNull: this.allowsNull,
            emptyStringAllowed: this.emptyStringAllowed,
            required: this.required,
            constraints,
        });
    }
    render() {
        return (h(Host, { key: '6e91ca0a5edaae540e96932f392d6fb099522e89' }, h("slot", { key: '6e2cb7953df1e21e5f362d324eadece4095ab49a' })));
    }
    static get is() { return "apie-form-field-definition"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-form-field-definition.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-form-field-definition.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "label",
                "reflect": false
            },
            "types": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "types",
                "reflect": false,
                "defaultValue": "'text'"
            },
            "additionalSettings": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "SingleFieldSettings",
                    "resolved": "SingleFieldSettings",
                    "references": {
                        "SingleFieldSettings": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::SingleFieldSettings"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{}"
            },
            "status": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "status",
                "reflect": true,
                "defaultValue": "'idle'"
            },
            "prototyped": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "prototyped",
                "reflect": true,
                "defaultValue": "false"
            },
            "valueWhenMissing": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "value-when-missing",
                "reflect": true,
                "defaultValue": "null"
            },
            "allowsNull": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "allows-null",
                "reflect": true,
                "defaultValue": "false"
            },
            "emptyStringAllowed": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "empty-string-allowed",
                "reflect": true,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "required",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get methods() {
        return {
            "getDefinition": {
                "complexType": {
                    "signature": "() => Promise<SingleField>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "SingleField": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::SingleField"
                        }
                    },
                    "return": "Promise<SingleField>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=apie-form-field-definition.js.map
